import { makeStyles, createStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

export default makeStyles<Theme>(theme =>
  createStyles({
    root: {
      paddingTop: 30,
      paddingBottom: 35,
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      [theme.breakpoints.up('md')]: {
        paddingTop: 45,
        paddingBottom: 50
      }
    },
    button: {
      maxWidth: 294,
      width: '100%',
      alignSelf: 'center'
    },
    table: {
      marginBottom: 40
    }
  }), { name: 'PrizeFond' }
);
